import { createGlobalStyle } from 'styled-components';

export const PrintStyles = createGlobalStyle`
    @media print {
        @page {
            size: A4;
            margin-left: 0;
            margin-right: 0;
            margin-bottom: 16px;
            margin-top: 16px;
            overflow: visible !important;
            display: block !important;
        }

        ::-webkit-scrollbar {
            display: none !important;
        }

        @page :first {
            margin: 0;
        }

        .no-print,
        .no-print * {
            display: none !important;
        }

        .print-only {
            display: inline !important;
        }

        .print-wrap {
            overflow-wrap: break-word;
        }

        /* tables */

        table {
            page-break-inside: auto;
        }

        // Printed tables looks cleaner without border, and it saves space
        .MuiTable-root {
            border-width: 0 !important;
        }

        // Keep headers, and cells spacing smaller
        .MuiTableCell-head {
            padding: 4px 0 !important;
            font-size: 11px !important;
            border-bottom-width: 2px !important;
        }

        .MuiTableCell-root {
            padding: 4px 0 !important;
            font-size: 12px !important;
        }

        // Avatars stack is a flex right align cell, in print it's the count we want to be left aligned.
        .usersAvatarWrapper {
            display: block !important;
        }

        tr {
            page-break-inside: avoid;
            page-break-after: auto;
        }

        .pageBreak + .pageBreak {
            page-break-before: always !important;
            page-break-inside: avoid !important;
        }

        .noBreak {
            page-break-inside: avoid;
        }

        .App {
            border: 0;
            width: 100%;
            background-color: ${(props) => props.theme.palette.background.white}
        }

        .MuiTab-root {
            display: none !important;
        }

        .hidePrint {
            display: none !important;
        }

        .showOnlyInPrint {
            display: flex !important;
        }

        .printMoveMarginLeft {
            margin-left: -4px !important;
        }

        .MuiPaper-root {
            width: 100%;
        }

        .MuiPaper-root:not(.MuiCard-root) {
            border: none !important;
        }

        .MuiGrid-container:has(> .MuiGrid-grid-xs-12) {
            display: block !important;
        }

        #mainViewSidebar {
            display: none !important;
        }

        #ada-button-frame {
            display: none !important;
        }

        #ada-chat-frame {
            display: none !important;
        }

        // This is probably all we need, but I'll leave the 2 other ada entries here just in case.
        #ada-entry {
            display: none !important;
        }

        #mainViewContainer {
            width: 100%;
            margin-top: 0px !important;
            margin-left: 0px !important;
            padding: 0px !important;
            padding-left: 10px !important;
            display: block !important;
        }

        /* page break */
        .break-after {
            display: block !important;
            break-after: page !important;
        }

        .break-before {
            display: block !important;
            page-break-before: always !important;
            break-before: page !important;
        }

        .break-auto {
            page-break-before: always !important;
            break-inside: auto !important;
        }

        ._pendo-badge {
            display: none !important;
        }

        .notResponsive th {
            white-space: nowrap !important;
            min-width: 0 !important;
        }

        .trialBannerMargin {
            margin-top: 0;
        }
    }
`;
